<template>
  <div class="row">
    <!-- end col -->
    <div class="col-xl-12 col-lg-8">
      <div class="card">
        <div class="card-body">
          <h4 class="header-title mb-3">API ключи</h4>
          <div class="row align-items-center">
            <div class="col-xl-12">
              <b-table hover :items="apiKeysItems" :fields="apiKeysFields"></b-table>
            </div>
            <button class="btn btn-success btn-xs waves-effect mb-2 waves-light" @click="generateNewKey">
              Generate a new key
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Sidepanel from "./sidepanel";
import { emailData } from "./data-inbox";
import Layout from "@layouts/main";
import axios from 'axios';
/**
 * Email-inbox component
 */
export default {
  head() {
    return {
      title: `Way Home | Ключи `,
    };
  },
  components: {
    Sidepanel,
    Layout,
  },
  data() {
    return {
      apiKeysItems: [],
      apiKeysFields: [{ label: "API Key", key: "api_key" }],
      emailData: emailData,
      paginatedEmailData: emailData,
      
      // page number
      currentPage: 1,
      // default page size
      perPage: 15,
      emailIds: [],
      // start and end index
      startIndex: 1,
      endIndex: 15,
    };
  },
  mounted() {
    this.loadAPIKeys();
  },
  computed: {
    rows() {
      return this.emailData.length;
    },
  },
  created() {
    this.startIndex = 0;
    this.endIndex = this.perPage;

    this.paginatedEmailData = this.emailData.slice(
      this.startIndex,
      this.endIndex
    );
  },
  methods: {
    loadAPIKeys() {
      let that = this;
      axios
        .get(`/api/secure/api_keys/?app=wh`)
        .then((response) => {
          const data = response.data;
          if (data.error) {
            throw data.error;
          }
          that.apiKeysItems = data.data;
        })
        .catch((e) => {
          throw new Error(e);
        });
    },
    generateNewKey() {
      let that = this;
      axios.post(`/api/secure/api_keys/`, {
        action: "new",
        app: "wh",
      })
        .then((response) => {
          const data = response.data;
          if (data.error) {
            throw data.error;
          }
          that.loadAPIKeys();
        })
        .catch((e) => {
          throw new Error(e);
        });
    },
    onPageChange() {
      this.startIndex = (this.currentPage - 1) * this.perPage;
      this.endIndex = (this.currentPage - 1) * this.perPage + this.perPage;

      this.paginatedEmailData = this.emailData.slice(
        this.startIndex,
        this.endIndex
      );
    },
  },
  middleware: "router-auth",
};
</script>
